import './App.css';
import BulletinBoard from './bulletinBoard/BulletinBoard';

function App() {
  return (
    <div className="App">
      <BulletinBoard/>
    </div>
  );
}

export default App;
